import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

const ExitIntentModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasTriggered, setHasTriggered] = useState(false);

  useEffect(() => {
    // Only trigger once per session
    if (sessionStorage.getItem('exitIntentTriggered')) {
      setHasTriggered(true);
      return;
    }

    const handleMouseLeave = (e) => {
      // If mouse leaves top of screen (moving to close tab or change URL)
      if (e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight)) {
        if (!hasTriggered) {
          setIsVisible(true);
          setHasTriggered(true);
          sessionStorage.setItem('exitIntentTriggered', 'true');
        }
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [hasTriggered]);

  const closeModal = () => setIsVisible(false);

  return (
    <AnimatePresence>
      {isVisible && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeModal}
            className="absolute inset-0 bg-secondary-900/60 backdrop-blur-sm"
          />

          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            className="relative bg-white rounded-3xl shadow-2xl max-w-lg w-full overflow-hidden flex flex-col md:flex-row z-10"
          >
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 z-10 bg-white/50 rounded-full p-1 backdrop-blur-sm"
            >
              <FaTimes />
            </button>

            <div className="md:w-2/5 bg-gradient-to-br from-amber-600 via-rose-600 to-purple-800 p-6 text-white flex flex-col items-center justify-center text-center relative overflow-hidden">
              <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] mix-blend-overlay"></div>
              <span className="text-5xl mb-3 animate-bounce">🪔</span>
              <h3 className="text-xl font-heading font-extrabold leading-tight">Diwali Dhamaka 2026</h3>
              <p className="text-[11px] text-amber-200 mt-1 uppercase tracking-wider font-semibold">Limited Festive Window</p>
            </div>

            <div className="p-8 md:w-3/5">
              <span className="text-xs font-bold text-rose-600 uppercase tracking-widest">Wait! Don't Miss Out</span>
              <h4 className="text-2xl font-black text-secondary-900 mt-1 mb-2">50% OFF First Month's Rent!</h4>
              <p className="text-gray-600 text-sm mb-4">
                Reserve your fully-furnished bed between <strong>1st–9th November 2026</strong> across our prime Pune locations.
              </p>

              <a
                href="https://wa.me/919960697118?text=Hi%20Chapter24!%20🪔%20I%20want%20to%20claim%20the%20Diwali%20Dhamaka%2050%25%20OFF%20offer%20on%20first%20month's%20rent!"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeModal}
                className="w-full text-center block mb-3 py-3 px-4 rounded-xl bg-gradient-to-r from-emerald-500 to-green-600 text-white font-bold hover:from-emerald-600 hover:to-green-700 transition shadow-md"
              >
                Claim 50% OFF via WhatsApp
              </a>

            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ExitIntentModal;
